import styled from 'styled-components'
import border from '../../tokens/border'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import layout from '../../tokens/layout'
import typography from '../../tokens/typography'

const selectWrapper = styled.div`
  display: grid;

  &.open {
    margin-bottom: ${layout.margin.spacingXxs};
  }

  * {
    font-family: ${fonts.inter};
    box-sizing: border-box;
  }
`

const inputWrapper = styled.div`
  display: grid;

  * {
    svg {
      color: ${colors.neutralColorLowDark};
      padding-left: ${layout.padding.spacingInsetNano} !important;
      min-height: 0.4rem;
      margin-right: ${layout.margin.spacingNano};
    }
  }

  &.open label:last-of-type {
    margin-bottom: ${layout.margin.spacingNone};
  }

  &.open input {
    border-bottom-left-radius: ${border.radius.radiusNone};
    border-bottom-right-radius: ${border.radius.radiusNone};
  }
`

const listContainer = styled.div`
  position: relative;

  * {
    padding: ${layout.padding.spacingInsetNone};
    margin: ${layout.margin.spacingNone};
  }

  > ul {
    width: 100%;
    display: grid;
    position: absolute;
    list-style: none;
    border: ${border.width.widthThin} solid ${colors.neutralColorLowLight};
    border-top: none;
    top: -2;
    padding-top: ${layout.padding.spacingInsetQuarck};
    max-height: ${layout.margin.spacingGiant};
    overflow-y: auto;
    background-color: ${colors.neutralColorHighPure};
    z-index: 999;

    li.empty-list {
      text-align: center;
      font-size: ${typography.fontSize.fontSizeXxs};
      color: ${colors.neutralColorLowMedium};
    }
  }
`

const listItem = styled.li`
  label {
    cursor: pointer;
    font-size: ${typography.fontSize.fontSizeXxs};
    display: flex;
    gap: ${layout.margin.spacingNano};
    padding: ${layout.padding.spacingInsetNano}
      ${layout.padding.spacingInsetNano};

    &:hover {
      background-color: ${colors.neutralColorHighMedium};
    }
  }
`

export const SelectTagStyles = {
  selectWrapper,
  inputWrapper,
  listContainer,
  listItem,
}
